<style lang="less">
.home-page {
    flex: 1;
    display: flex;
    outline: none;
    overflow: hidden;
    transition: background-color 0.5s linear 0.5s;
    &-left {
        height: 100%;
        overflow: hidden;
    }
    &-right {
        flex: 1;
        display: flex;
        align-items: center;
        &-box {
            box-sizing: border-box;
            background: #f6f7f9;
            &-title {
                font-family: OPPOSans;
                color: #33383e;
            }
            &-desc {
                color: #9da3ac;
            }
            &-btns {
                display: flex;
                &-upload {
                    .upload-btn {
                        background: #2254f4;
                        &:focus {
                            outline: none;
                        }
                        &:hover {
                            background-color: #1338cf;
                        }
                    }
                }
                &-test {
                    cursor: pointer;
                    color: #474b51e6;
                    background-color: transparent;
                    &:focus {
                        outline: none;
                    }
                    &:hover {
                        border-color: #d9dcdf;
                    }
                }
            }
        }
    }
    @media screen and (min-width: 1920px) {
        &-left {
            width: 62.5%;
        }
        &-right {
            &-box {
                width: 640px;
                height: 500px;
                border-radius: 14.0351px;
                padding: 73.68px 0 0 74.39px;
                &-title {
                    font-weight: bold;
                    font-size: 42.1053px;
                    line-height: 56px;
                }
                &-desc {
                    margin-top: 13.3px;
                    font-size: 24.5614px;
                    line-height: 32px;
                }
                &-btns {
                    margin-top: 149.56px;
                    &-upload {
                        .upload-btn {
                            box-sizing: border-box;
                            width: 228px;
                            height: 60px;
                            border-radius: 3.50877px;
                            font-size: 19.2982px;
                            font-weight: bold;
                            border: 1.75439px solid #e8eaec;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            & > img {
                                width: 21.05px;
                                height: 21.05px;
                                margin-right: 11.4px;
                            }
                        }
                    }
                    &-test {
                        margin-left: 12.3px;
                        width: 175px;
                        height: 60px;
                        font-size: 19.2982px;
                        line-height: 27px;
                        border-radius: 2px;
                        border: 1.75439px solid #e8eaec;
                    }
                    &-qrcode {
                        margin-left: 11.7px;
                        &-image {
                            box-sizing: border-box;
                            height: 60px;
                            width: 60px;
                            border: 1.75439px solid #e8eaec;
                            border-radius: 3.50877px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                    }
                }
                &-key {
                    font-size: 12px;
                    line-height: 21px;
                    color: #111111;
                    opacity: 0.9;
                    margin-top: 20.26px;
                    span {
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        width: 28.07px;
                        height: 17.54px;
                        background: #ffffff;
                        border-radius: 1.75439px;
                    }
                }
            }
        }
    }
    @media screen and (max-width: 1919px) {
        &-left {
            width: 56%;
        }
        &-right {
            &-box {
                width: 512px;
                height: 400px;
                border-radius: 11.2281px;
                padding: 61px 0 0 58px;
                &-title {
                    font-weight: bold;
                    font-size: 34px;
                    line-height: 45px;
                }
                &-desc {
                    margin-top: 9px;
                    font-size: 20px;
                    line-height: 26px;
                }
                &-btns {
                    margin-top: 120px;
                    &-upload {
                        .upload-btn {
                            box-sizing: border-box;
                            width: 182px;
                            height: 48px;
                            border-radius: 2.80702px;
                            font-size: 15px;
                            font-weight: bold;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            & > img {
                                width: 14.22px;
                                height: 13.96px;
                                margin-right: 8.78px;
                            }
                            &:focus {
                                outline: none;
                            }
                        }
                    }
                    &-test {
                        margin-left: 12.3px;
                        width: 140px;
                        height: 48px;
                        font-size: 15px;
                        line-height: 21px;
                        border-radius: 2.80702px;
                        box-sizing: border-box;
                        border: 1.40351px solid #e8eaec;
                    }
                    &-qrcode {
                        margin-left: 12px;
                        &-image {
                            box-sizing: border-box;
                            height: 48px;
                            width: 48px;
                            border: 1.75439px solid #e8eaec;
                            border-radius: 2.80702px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                    }
                }
                &-key {
                    font-size: 12px;
                    line-height: 17px;
                    color: #111111;
                    opacity: 0.9;
                    margin-top: 16.21px;
                    span {
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        width: 28.07px;
                        height: 17.54px;
                        background: #ffffff;
                        border-radius: 1.75439px;
                    }
                }
            }
        }
    }
}
</style>
<template>
    <div class="home-page" :style="{ backgroundColor }">
        <div class="home-page-left">
            <Carousel :activeId.sync="activeId" />
        </div>
        <div class="home-page-right">
            <div class="home-page-right-box">
                <h2 class="home-page-right-box-title">轻松编辑你的图片</h2>
                <p class="home-page-right-box-desc">手机和电脑随时随地创作</p>
                <div class="home-page-right-box-btns">
                    <UploadBtn
                        class="home-page-right-box-btns-upload"
                        @upload="(files) => onUpload([files[0]])"
                        @click.native="onUploadClick"
                    />
                    <button
                        class="home-page-right-box-btns-test"
                        @click="openExample"
                    >
                        试试样片
                    </button>
                    <QrCode class="home-page-right-box-btns-qrcode">
                        <div class="home-page-right-box-btns-qrcode-image">
                            <img src="../../assets/qrcode-btn.svg" />
                        </div>
                    </QrCode>
                </div>
                <p class="home-page-right-box-key">
                    支持拖拽或粘贴图片&emsp;
                    <span>{{ isWindows ? "ctrl" : "⌘" }}</span> + <span>V</span>
                </p>
            </div>
        </div>
        <!-- 加载状态 -->
        <Loading
            :content="loadingOpt.content"
            :show="loadingOpt.show"
            :cancelText="loadingOpt.cancelText"
            :cancelable="loadingOpt.cancelable"
            :loader="loadingOpt.loader"
            :lock="loadingOpt.lock"
            @cancel="loadingOpt.cancel"
        />
        <FilePicker
            ref="filePicker"
            :strictMIMEValidation="true"
            :drag-and-drop="true"
            :multiple="true"
            :max="40"
            @change="onUpload"
            @dragover="toggleDragModalShow(true)"
            @dragleave="toggleDragModalShow(false)"
            @drop="toggleDragModalShow(false)"
            @error="handleDragError"
        />
        <DragModal :show="showDragModal" />
    </div>
</template>

<script>
import UploadBtn from "@gaoding/gd-materials/lib/editor-nav/components/upload-btn";
import { Loading, FilePicker } from "@gaoding/editor-ui";
import { Message } from "@gaoding/gdui";
import QrCode from "./qr-code";
import Carousel from "./carousel";
import DragModal from "./drop-modal";

import { validateFiles } from "../../utils/image-validate";
import {isFireFox} from '../../utils/ua';
import { resourceTracker } from '@/trackers';

export default {
    name: "home-page",
    components: {
        UploadBtn,
        QrCode,
        Carousel,
        Loading,
        FilePicker,
        DragModal,
    },
    data() {
        return {
            activeId: 1,
            showDragModal: false,
            loadingOpt: {
                content: "",
                loader: true,
                show: false,
                cancelText: "",
                cancelable: false,
                lock: false,
                cancel: () => {},
            },
        };
    },
    methods: {
        openExample() {
            this.$router.push({
                name: "editor-page",
                query: { mode: "example" },
            });
            resourceTracker.click({
                click_source: 'uupoop',
                resource_type: '顶部导航栏',
                resource_title: '试试样片'
            });
        },
        onUploadClick() {
            resourceTracker.click({
                click_source: 'uupoop',
                resource_type: '顶部导航栏',
                resource_title: '上传图片'
            });
        },
        async onUpload(files) {
            if (!files || files.length < 1) return;
            this.loadingOpt.show = true;
            try {
                const validFiles = await validateFiles(files);
                // const res = await Uploader.upload(validFiles[0]);
                this.$store.commit("setFiles", validFiles);

                this.loadingOpt.show = false;
                this.$router.push({
                    name: "editor-page",
                    // query: { url: encodeURI(res.url) },
                });
            } catch (err) {
                this.loadingOpt.show = false;
                console.log(err);
            }
        },
        handlePaste(event) {
            const items = event.clipboardData && event.clipboardData.items;
            const files = Array.from(items)
                .map((item) => {
                    if (item && item.type.indexOf("image") !== -1) {
                        return item.getAsFile();
                    }
                })
                .filter((v) => !!v);

            if (files && files.length) {
                this.onUpload(files);
            }
        },
        toggleDragModalShow(isShow) {
            this.showDragModal = isShow;
        },
        handleDragError(msg) {
            Message({
                type: "error",
                message: msg,
            });
        },
    },
    mounted() {
        document.body.addEventListener("paste", this.handlePaste);
    },
    computed: {
        backgroundColor() {
            const colors = ["#00C2CA", "#BAB9ED", "#04BDFF", "#EBEBEB"];
            const firefoxColors = ["#00caba", "#aba2ea", "#00beff", "#e4e4e4"];
            return isFireFox() ? firefoxColors[this.activeId-1] : colors[this.activeId-1]
        },
        isWindows() {
            return /windows/i.test(navigator.userAgent);
        },
    },
};
</script>
